var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import { ComponentException } from '@inter-ikea-kompis/exceptions';
import { KeyboardTypeEnum } from '@inter-ikea-kompis/keyboard-manager';
import KeyboardKeyCodeEnum from '../../enums/KeyboardKeyCodeEnum.js';
import KeyboardButtonStyle from './KeyboardButtonStyle.js';
export default class KeyboardButton extends KompisElement {
    constructor() {
        super(...arguments);
        // Key code
        this.keyCode = null;
        // Type of keyboard.
        this.type = KeyboardTypeEnum.text;
        // Locale is used to determine the type of decimal symbol (comma or point) on the "decimal" keyboard layout.
        this.locale = null;
        this.listeners = {
            mouseUp: this.onMouseUp.bind(this),
            mouseDown: this.onMouseDown.bind(this),
            mouseLeave: this.onMouseLeave.bind(this)
        };
        this.active = false;
    }
    /**
     * Renders the component.
     *
     * @returns Template.
     */
    render() {
        return html `
			<style>
				${KeyboardButtonStyle.getStyle({
            theme: this.theme,
            keyCode: this.keyCode,
            type: this.type,
            isActive: this.active
        })}
			</style>
			<button
				@mousedown="${this.listeners.mouseDown}"
				@mouseup="${this.listeners.mouseUp}"
				@mouseleave="${this.listeners.mouseLeave}"
				@touchstart="${this.listeners.mouseDown}"
				@touchend="${this.listeners.mouseUp}"
			>
				<div>${this.getKeyText()}</div>
			</button>
		`;
    }
    /**
     * Return key text.
     *
     * @returns Key text.
     */
    getKeyText() {
        switch (this.keyCode) {
            case KeyboardKeyCodeEnum.backspace:
                return '⟵';
            case KeyboardKeyCodeEnum.space:
                return '␣';
            case KeyboardKeyCodeEnum.decimal:
                return this.getDecimalSymbol();
        }
        return this.keyCode;
    }
    /**
     * Returns the decimal key text.
     *
     * @returns Key text.
     */
    getDecimalSymbol() {
        if (!this.locale) {
            throw new ComponentException('Failed get decimal symbol. The prop "locale" has not been defined.');
        }
        return (1.1).toLocaleString(this.locale).includes(',') ? ',' : '.';
    }
    /**
     * Handles mouse down event.
     *
     * @param event HTMLEvent.
     */
    onMouseDown(event) {
        if (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        event.sourceCapabilities &&
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            event.sourceCapabilities.firesTouchEvents &&
            event.type === 'mousedown') {
            return;
        }
        this.active = true;
        this.update();
    }
    /**
     * Handles mouse up event.
     *
     * @param event HTMLEvent.
     */
    onMouseUp(event) {
        if (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        event.sourceCapabilities &&
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            event.sourceCapabilities.firesTouchEvents &&
            event.type === 'mouseup') {
            return;
        }
        this.active = false;
        this.update();
    }
    /**
     * Handles mouse leave.
     */
    onMouseLeave() {
        if (this.active) {
            this.active = false;
            this.update();
        }
    }
}
__decorate([
    property({ type: String })
], KeyboardButton.prototype, "keyCode", void 0);
__decorate([
    property({ type: String })
], KeyboardButton.prototype, "type", void 0);
__decorate([
    property({ type: String })
], KeyboardButton.prototype, "locale", void 0);
__decorate([
    property({ type: Object, required: true })
], KeyboardButton.prototype, "theme", void 0);
//# sourceMappingURL=KeyboardButton.js.map